export default {
  // isFetchedToEnd(state) {
  //   if (state.agents.length > 0) {
  //     // if have articles in store
  //     // check if the new fetched articles are empty or not
  //     if (state.agents[state.agents.length - 1].emp_id == null) {
  //       return true;
  //     }
  //     return false;
  //   }
  //   return true;
  // },
};
